import type { Attribution, MokiSession } from "./types";

const STORAGE_KEY = "moki-prelaunch-session-v1";

function newAnonymousId(): string {
  return crypto.randomUUID();
}

export function getSession(): MokiSession {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw) as MokiSession;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
  }

  const created: MokiSession = { anonymousId: newAnonymousId(), attribution: {} };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(created));
  return created;
}

export function updateSession(patch: Partial<MokiSession>): MokiSession {
  const current = getSession();
  const next = { ...current, ...patch, attribution: patch.attribution ?? current.attribution };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("moki-session", { detail: next }));
  return next;
}

export function captureAttribution(): Attribution {
  const params = new URLSearchParams(window.location.search);
  const next: Attribution = { ...getSession().attribution };
  const keys: Array<keyof Attribution> = [
    "utm_source", "utm_medium", "utm_campaign", "utm_content",
    "creative_id", "hook_variant", "landing_variant",
  ];
  for (const key of keys) {
    const value = params.get(key);
    if (value) next[key] = value.slice(0, 160);
  }
  // TikTok (ttclid) and Meta (fbclid) click ids: they let TikTok match a signup back to the ad.
  for (const key of ["ttclid", "fbclid"] as const) {
    const value = params.get(key);
    if (value) next[key] = value.slice(0, 200);
  }
  if (!next.landing_path) next.landing_path = window.location.pathname.slice(0, 200);
  const referral = params.get("ref");
  if (referral) next.referrer_code = referral.slice(0, 32);
  if (!next.source) next.source = document.referrer ? "referral" : "direct";
  updateSession({ attribution: next });
  return next;
}
